import { updatableListActions } from '../../GeneralListFunctions/actionFactory'
export default updatableListActions('SELECT_ORGANIZATION')
